module.exports = __webpack_public_path__ + "static/orthodontics04-f0cfb2b02d82d40139db746ec34a35c7.jpg";